import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { MenuContext } from "./context/menu-context.js";
import classnames from "classnames";
import styles from "./AuthenticatedApp.module.css";
import Nav from "./components/Nav.js";
import Home from "./screens/Home.js";
import ReservationForm from "./screens/ReservationForm";
import Calendar from "./screens/Calendar";
import MyReservations from "./screens/MyReservations";
import Profile from "./screens/Profile";
import ChangePassword from "./screens/ChangePassword";
import Rules from "./screens/Rules";
import Today from "./screens/Today";
import Admin from "./screens/Admin";
import NewUser from "./screens/Admin/Users/NewUser.js";
import User from "./screens/Admin/Users/User.js";
import Users from "./screens/Admin/Users.js";
import Events from "./screens/Admin/Events.js";
import EditUser from "./screens/Admin/Users/EditUser.js";

function AuthenticatedApp({ onLogout }) {
  return (
    <div>
      <Routes>
        <Route exact path="/today" element={<Today />} />
        <Route path="/*" element={<DefaultContainer onLogout={onLogout} />} />
      </Routes>
    </div>
  );
}

function DefaultContainer({ onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const appClasses = classnames(styles.app, {
    [styles.open]: menuOpen,
  });
  const mainContentClasses = classnames(styles.mainContent, {
    [styles.open]: menuOpen,
  });
  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <MenuContext.Provider value={{ toggleMenu, menuOpen }}>
      <div className={appClasses}>
        <Nav isOpen={menuOpen} onItemClick={() => setMenuOpen(false)} />
        <div className={mainContentClasses}>
          <Routes>
            <Route path="/*" element={<Home />} />
            <Route path="/reservations" element={<ReservationForm />}>
              <Route
                path="/reservations/:reservationId"
                element={<ReservationForm />}
              />
            </Route>
            <Route path="/calendar" element={<Calendar />}>
              <Route path=":date" element={<Calendar />} />
              <Route path=":date/:reservationId" element={<Calendar />} />
            </Route>
            <Route path="/my_reservations" element={<MyReservations />} />
            <Route
              path="/my_profile"
              element={<Profile onLogout={onLogout} />}
            />
            <Route path="/change_password" element={<ChangePassword />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/admin" element={<Admin />}>
              <Route index element={<Navigate to="events" replace />} />
              <Route path="events" element={<Events />} />
              <Route path="users" element={<Users />} />
              <Route path="users/new" element={<NewUser />} />
              <Route path="users/:userId" element={<User />} />
              <Route path="users/:userId/edit" element={<EditUser />} />
              {/* <Route path="/admin/recurring_reservations" element={<Admin />} />
            <Route path="/admin/schedule" element={<Admin />} /> */}
            </Route>
          </Routes>
        </div>
      </div>
    </MenuContext.Provider>
  );
}

export default AuthenticatedApp;
